"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = "<?xml version=\"1.0\" ?>\n<Relationships xmlns=\"http://schemas.openxmlformats.org/package/2006/relationships\">\n<Relationship Id=\"rId3\" Target=\"worksheets/sheet1.xml\" Type=\"http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet\"/>\n</Relationships>";